import { Formik, Form } from "formik";
import useTutorial from "../../../hooks/useTutorial";
import TitleWithPopover from "../../../components/title-with-popover";
import { BaSeInput, BaSeGrid, BaSeGridItem, BaSeHeading5 } from "@base/react";

const TutorialMonthlyAverage = () => {
  const PAGE_KEY = "mediaMensal";

  useTutorial({
    currentStep: "8",
    pageKey: "mediaMensal",
    previousKey: "nomeDoPlanejamento",
    steps: [
      {
        element: ".monthly-average",
        popover: {
          title: "Média Mensal",
          description: `Registre sua média mensal de faturamento e despesas para obter uma visão mais clara da saúde
          financeira da sua empresa.`,
          side: "bottom",
          align: "center",
        },
        onHighlighted: () => {
          const sideBar = document.querySelector(".list-menu");
          if (sideBar) {
            sideBar.classList.remove("open");
          }
        },
      },
    ],
    onNextButtonClick: (driverObj) => {
      const tutorials = JSON.parse(localStorage.getItem("tutorials")) || {};

      if (tutorials["custosIndiretosVariaveis"]) {
        tutorials["custosIndiretosVariaveis"].finalizado = false;
      }

      tutorials[PAGE_KEY] = { ...tutorials[PAGE_KEY], finalizado: true };
      localStorage.setItem("tutorials", JSON.stringify(tutorials));

      const botaoProx = document.querySelector("#botaoSeguirTutorial button");
      botaoProx.click();
      driverObj.drive(0);
    },
  });

  return (
    <div className="step monthly-average">
      <BaSeHeading5
        color="#005EB8"
        fontFamily="Alegreya Sans"
        isBold
        className="mt-0"
      >
        Média Mensal
      </BaSeHeading5>

      <Formik>
        {() => (
          <Form>
            <TitleWithPopover
              title="Receita total"
              messagePopover="Para negócios em funcionamento, insira o valor médio mensal das vendas dos últimos três meses. Se você está planejando um novo negócio, informe o valor da meta estabelecida para a receita mensal."
            />
            <BaSeGrid>
              <BaSeGridItem size={6}>
                <BaSeInput
                  isDisabled
                  color="default"
                  inputMode="tel"
                  typeInput="tel"
                  placeholder="R$"
                  maxLength={22}
                  prefix="R$ "
                  mask="decimal"
                  size="medium"
                  label="Produtos"
                  width="100%"
                />
              </BaSeGridItem>
              <BaSeGridItem size={6}>
                <BaSeInput
                  isDisabled
                  color="default"
                  inputMode="decimal"
                  typeInput="tel"
                  placeholder="R$"
                  maxLength={22}
                  prefix="R$ "
                  mask="decimal"
                  size="medium"
                  label="Serviços"
                  width="100%"
                />
              </BaSeGridItem>
            </BaSeGrid>

            <TitleWithPopover
              title="Custo com mercadorias"
              messagePopover={[
                "Para negócios em funcionamento, informe o valor médio dos custos dos últimos três meses.",
                "\n\nCaso esteja planejando um novo negócio, insira o custo das mercadorias de acordo com a meta de vendas mensais estabelecida.",
              ]}
            />
            <BaSeGrid>
              <BaSeGridItem size={6}>
                <BaSeInput
                  isDisabled
                  color="default"
                  inputMode="decimal"
                  typeInput="tel"
                  placeholder="R$"
                  maxLength={22}
                  prefix="R$ "
                  mask="decimal"
                  size="medium"
                  label="Produtos"
                  width="100%"
                />
              </BaSeGridItem>
              <BaSeGridItem size={6}>
                <BaSeInput
                  isDisabled
                  color="default"
                  inputMode="decimal"
                  typeInput="tel"
                  placeholder="R$"
                  maxLength={22}
                  prefix="R$ "
                  mask="decimal"
                  size="medium"
                  label="Serviços"
                  width="100%"
                />
              </BaSeGridItem>
            </BaSeGrid>

            <TitleWithPopover
              title="Custos Indiretos Fixos"
              messagePopover="Informe a soma de todos os custos fixos mensais, como aluguel e outras despesas recorrentes."
            />
            <BaSeGrid>
              <BaSeGridItem size={6}>
                <BaSeInput
                  isDisabled
                  color="default"
                  inputMode="decimal"
                  typeInput="tel"
                  placeholder="R$"
                  maxLength={22}
                  prefix="R$ "
                  mask="decimal"
                  size="medium"
                  label="Valor"
                  width="100%"
                />
              </BaSeGridItem>
            </BaSeGrid>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default TutorialMonthlyAverage;
